import { render, staticRenderFns } from "./_ObjectToProtect.vue?vue&type=template&id=22eb1c73&scoped=true&"
import script from "./_ObjectToProtect.vue?vue&type=script&lang=js&"
export * from "./_ObjectToProtect.vue?vue&type=script&lang=js&"
import style0 from "./_ObjectToProtect.vue?vue&type=style&index=0&id=22eb1c73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eb1c73",
  null
  
)

export default component.exports